import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header, { scrollToId } from "./components/site/Header";
import Hero from "./components/site/Hero";
import { Services, Sectors, Included } from "./components/site/Sections";
import Projects from "./components/site/Projects";
import { About, Testimonial } from "./components/site/About";
import { Contact, Footer } from "./components/site/Contact";
import QuoteModal from "./components/site/QuoteModal";
import ProjectDetail from "./components/site/ProjectDetail";
import Admin from "./components/site/Admin";

const Home = ({ onQuote }) => {
  const loc = useLocation();
  useEffect(() => {
    const id = loc.state?.scrollTo;
    if (id) setTimeout(() => scrollToId(id), 80);
    else window.scrollTo(0, 0);
  }, [loc.key]); // eslint-disable-line
  return (
    <main>
      <Hero onQuote={onQuote} />
      <Services />
      <Sectors />
      <Projects />
      <Included />
      <About />
      <Testimonial />
      <Contact />
    </main>
  );
};

const RevealObserver = () => {
  const loc = useLocation();
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("in")),
      { threshold: 0.12 }
    );
    const scan = () => document.querySelectorAll(".reveal:not(.in)").forEach((el) => obs.observe(el));
    scan();
    const mo = new MutationObserver(scan);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { obs.disconnect(); mo.disconnect(); };
  }, [loc.pathname]);
  return null;
};

const SiteChrome = ({ onQuote }) => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return <Admin />;
  return (
    <>
      <Header onQuote={onQuote} />
      <Routes>
        <Route path="/" element={<Home onQuote={onQuote} />} />
        <Route path="/projects/:slug" element={<ProjectDetail onQuote={onQuote} />} />
        <Route path="*" element={<Home onQuote={onQuote} />} />
      </Routes>
      <Footer />
    </>
  );
};

function App() {
  const [quote, setQuote] = useState(false);
  const openQuote = () => setQuote(true);

  return (
    <div className="App bg-black">
      <BrowserRouter>
        <RevealObserver />
        <SiteChrome onQuote={openQuote} />
      </BrowserRouter>
      <QuoteModal open={quote} onOpenChange={setQuote} />
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
